/**
 * @generated SignedSource<<c17231cfebe07e14cfe487d64571e311>>
 * @relayHash 5e797597314531dc1e78e1c5923259be
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/579.0.0-2026-10-05T13:12:26.429Z/sitemapRootQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterType = "artOrientation" | "artSize" | "caratWeight" | "color" | "creators" | "dealers" | "designSeries" | "designs" | "framingStatus" | "items" | "jewelryType" | "location" | "material" | "metal" | "origin" | "period" | "ringSize" | "stone" | "stoneCut" | "style" | "technique" | "%future added value";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type sitemapRootQuery$variables = {
  filterType?: FilterType | null;
  filterTypeValue?: string | null;
  level?: number | null;
  pageNumber?: number | null;
  vertical?: VerticalType | null;
};
export type sitemapRootQuery$data = {
  readonly viewer: {
    readonly sitemap: {
      readonly tabTitle: string | null;
      readonly totalLinks: number | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"SitemapWrapper_viewer">;
  };
};
export type sitemapRootQuery = {
  response: sitemapRootQuery$data;
  variables: sitemapRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterTypeValue"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "level"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageNumber"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vertical"
},
v5 = [
  {
    "kind": "Variable",
    "name": "filterType",
    "variableName": "filterType"
  },
  {
    "kind": "Variable",
    "name": "filterTypeValue",
    "variableName": "filterTypeValue"
  },
  {
    "kind": "Variable",
    "name": "level",
    "variableName": "level"
  },
  {
    "kind": "Variable",
    "name": "pageNumber",
    "variableName": "pageNumber"
  },
  {
    "kind": "Variable",
    "name": "vertical",
    "variableName": "vertical"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tabTitle",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalLinks",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkUrl",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/),
      (v4/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "sitemapRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SitemapWrapper_viewer"
          },
          {
            "alias": null,
            "args": (v5/*:: as any*/),
            "concreteType": "Sitemap",
            "kind": "LinkedField",
            "name": "sitemap",
            "plural": false,
            "selections": [
              (v6/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*:: as any*/),
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "sitemapRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*:: as any*/),
            "concreteType": "Sitemap",
            "kind": "LinkedField",
            "name": "sitemap",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SitemapLink",
                "kind": "LinkedField",
                "name": "sitemapLinks",
                "plural": true,
                "selections": [
                  (v8/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "linksType",
                    "storageKey": null
                  },
                  (v9/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "linkItems",
                    "kind": "LinkedField",
                    "name": "items",
                    "plural": true,
                    "selections": [
                      (v8/*:: as any*/),
                      (v9/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "l3LinkItems",
                        "kind": "LinkedField",
                        "name": "items",
                        "plural": true,
                        "selections": [
                          (v8/*:: as any*/),
                          (v10/*:: as any*/),
                          (v9/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v10/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "headerText",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "resultsHeader",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*:: as any*/),
              (v7/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/579.0.0-2026-10-05T13:12:26.429Z/sitemapRootQuery",
    "metadata": {},
    "name": "sitemapRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9c4593ccea61b2af27a3900942d0afc8";

export default node;
